import React from 'react';
import { motion } from 'framer-motion';
import { FileText, CheckSquare, MessageCircle, FolderOpen } from 'lucide-react';
import { Button } from './ui/Button';
export const Deliverables = () => {
  const items = [{
    icon: FileText,
    title: 'PDF "La Ruta Clara"',
    desc: 'Guía completa 18–24 meses'
  }, {
    icon: CheckSquare,
    title: 'Checklist Semáforo',
    desc: 'Verde / Amarillo / Rojo en 1 página'
  }, {
    icon: ClipboardListIcon,
    title: 'Tracker Imprimible',
    desc: 'Registro de 7 días (versión completa + simple)'
  }, {
    icon: MessageCircle,
    title: 'Guiones Copy/Paste',
    desc: 'Para pediatra, daycare y familia'
  }, {
    icon: FolderOpen,
    title: 'Plantilla de Evidencia',
    desc: 'Qué llevar a consulta y cómo decirlo'
  }];
  return <section className="w-full bg-[#FFF9F3] py-20 px-4" data-id="element-30">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-[#1B2A4A]/5" data-id="element-31">
        <div className="p-8 md:p-12" data-id="element-32">
          <div className="text-center mb-10" data-id="element-33">
            <h2 className="text-3xl font-serif font-bold text-[#1B2A4A] mb-2" data-id="element-34">
              Lo que recibes hoy
            </h2>
            <p className="text-[#2D3436]/70" data-id="element-35">Para que no quede ninguna duda.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-36">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-[#FFF9F3] transition-colors" data-id="element-37">
                <div className="bg-[#2ABFBF]/10 p-2 rounded-lg text-[#2ABFBF]" data-id="element-38">
                  <item.icon className="w-6 h-6" data-id="element-39" />
                </div>
                <div data-id="element-40">
                  <h3 className="font-bold text-[#1B2A4A]" data-id="element-41">{item.title}</h3>
                  <p className="text-sm text-[#2D3436]/80" data-id="element-42">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div id="precio" className="bg-[#1B2A4A] rounded-2xl p-8 text-center text-white" data-id="element-43">
            <h3 className="text-2xl font-bold mb-2" data-id="element-44">Quiero mi Ruta Clara</h3>

            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-45">
              <span className="text-white/50 line-through text-xl" data-id="element-46">$19.00</span>
              <span className="text-4xl font-black text-[#2ABFBF]" data-id="element-47">$6.39</span>
            </div>

            <p className="mb-6 opacity-90 text-sm md:text-base" data-id="element-48">
              No porque el tema sea "pequeño". Sino porque necesitas algo
              accesible hoy.
            </p>
            <Button variant="secondary" size="lg" fullWidth className="md:max-w-md mx-auto shadow-none hover:shadow-lg" data-id="element-49">
              Obtener Acceso Inmediato
            </Button>
          </div>
        </div>
      </div>
    </section>;
};
// Helper for the icon since I used a variable name that might not exist in scope
const ClipboardListIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-50">
    <rect width="8" height="4" x="8" y="2" rx="1" ry="1" data-id="element-51" />
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" data-id="element-52" />
    <path d="M9 12h6" data-id="element-53" />
    <path d="M9 16h6" data-id="element-54" />
    <path d="M9 8h6" data-id="element-55" />
  </svg>;